import React from 'react';
import { CheckIcon } from 'lucide-react';
import { tomos, tomoIncludes } from '../data/tomos';
import { Emoji } from './Emoji';
export function Tomos() {
  return <section id="megapack" className="w-full bg-forest-900 py-14 sm:py-16" data-id="element-257" data-mp="139ux0dw7a57k">
      <div className="mx-auto w-full max-w-[680px] px-4 text-center sm:px-6 lg:max-w-[900px]" data-id="element-258" data-mp="1h4dty9tdkgih">
        <h2 className="font-display text-[clamp(1.6rem,6vw,2.5rem)] font-extrabold uppercase leading-[1.05] tracking-tight text-cream" data-id="element-259" data-mp="1cat1exajweqo">
          Mega Pack Cocina Lista
        </h2>
        <p className="mt-3 font-display text-[clamp(1.15rem,4.5vw,1.875rem)] font-extrabold tracking-tight text-lime-400" data-id="element-260" data-mp="1m1dzmjmbbh92">
          6 Tomos + 6 Bonos — Todo resuelto.
        </p>

        <ul className="mt-8 grid grid-cols-3 gap-2.5 sm:grid-cols-6 sm:gap-3" data-id="element-261" data-mp="1w03iofpy37qw">
          {tomos.map(tomo => <li key={tomo.number} className="flex h-20 flex-col justify-end rounded-lg p-2 shadow-card sm:h-28" style={{
          backgroundColor: tomo.accent
        }} data-id="element-262" data-mp="5oz0hg0dk6s4">
              <span className="font-display text-[10px] font-extrabold uppercase leading-tight tracking-tight text-forest-950 sm:text-[11px]" data-id="element-263" data-mp="34sb0jxbs52j2">
                {tomo.tag}
              </span>
            </li>)}
        </ul>

        <div className="mt-8 rounded-3xl border border-lime-400/20 bg-forest-950 px-4 py-6 text-left sm:px-7 sm:py-8" data-id="element-264" data-mp="3en2y515d3pdu">
          <p className="inline-flex items-center gap-2 font-display text-base font-extrabold uppercase tracking-[0.16em] text-lime-400 sm:text-lg" data-id="element-265" data-mp="3oez7j8cwf1xd">
            <Emoji symbol="💪" data-id="element-266" data-mp="3sepwd6iv77z9" />
            6 tomos completos
          </p>

          <ol className="mt-6 flex flex-col gap-7 lg:grid lg:grid-cols-2 lg:gap-8" data-id="element-267" data-mp="1b16djzyf4uw">
            {tomos.map(tomo => <li key={tomo.number} className="flex gap-3 sm:gap-4" data-id="element-268" data-mp="68klem4h7lnw">
                <span aria-hidden="true" className="mt-1.5 h-3.5 w-3.5 shrink-0 rounded-[3px] sm:h-4 sm:w-4" style={{
              backgroundColor: tomo.accent
            }} data-id="element-269" data-mp="2325z6jdmibgt" />
                <div className="min-w-0" data-id="element-270" data-mp="200jbv6z4sjht">
                  <h3 className="font-display text-[14px] font-extrabold leading-snug text-cream sm:text-[15px]" data-id="element-271" data-mp="1vy64ke4qkdix">
                    <Emoji symbol={tomo.emoji} className="mr-2" data-id="element-272" data-mp="29xnuiwtrpwtv" />
                    Tomo {tomo.number} —{' '}
                    <span className="uppercase" data-id="element-273" data-mp="24yl2ccyvzl3b">{tomo.title}</span>
                  </h3>

                  <ul className="mt-3 flex flex-col gap-2" data-id="element-274" data-mp="2iy3x842oszxo">
                    {tomo.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2.5 text-[13px] leading-snug text-cream/85 sm:text-[14px]" data-id="element-275" data-mp="2extq2o35s3h8">
                        <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-lime-500" data-id="element-276" data-mp="2nqdjna4lfhv7">
                          <CheckIcon className="h-2.5 w-2.5 text-forest-950" strokeWidth={4} aria-hidden="true" data-id="element-277" data-mp="32muum08veuh8" />
                        </span>
                        <span className="min-w-0" data-id="element-278" data-mp="3lbf2fqjh0law">{bullet}</span>
                      </li>)}
                  </ul>
                </div>
              </li>)}
          </ol>
        </div>

        <p className="mx-auto mt-8 flex max-w-xl flex-wrap items-center justify-center gap-2 font-display text-base font-extrabold tracking-tight text-cream sm:text-xl" data-id="element-279" data-mp="3c95vfaneva29">
          6 tomos. 6 situaciones distintas de tu vida. Un solo sistema que las
          resuelve todas.
          <Emoji symbol="🌿" data-id="element-280" data-mp="2okwaeay0uqc6" />
        </p>

        <div className="mt-10 rounded-3xl border border-lime-400/20 bg-forest-800 px-5 py-7 text-left sm:px-8 sm:py-8" data-id="element-281" data-mp="2om7gwiiuqc6z">
          <h3 className="text-center font-display text-base font-extrabold uppercase tracking-[0.12em] text-cream sm:text-lg" data-id="element-282" data-mp="2thmtz891c42c">
            Cada tomo incluye
          </h3>
          <ul className="mt-6 grid gap-4 sm:grid-cols-2" data-id="element-283" data-mp="2jk8fhe6o9pco">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-284" data-mp="3mvxmco631oyp">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-lime-500" data-id="element-285" data-mp="3hwuih71u9osb">
                  <CheckIcon className="h-3 w-3 text-forest-950" strokeWidth={3} aria-hidden="true" data-id="element-286" data-mp="3d5m8a8sopze3" />
                </span>
                <span className="min-w-0 text-[14px] font-medium leading-relaxed text-cream/85 sm:text-[15px]" data-id="element-287" data-mp="3399df7lelfhr">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}